<template>
  <div class="teacherManger">
    <!-- 校园树 -->
    <!-- <el-aside width="240px" style="padding-right:10px;overflow: auto;background: #fff;border-radius: 4px;">
        <div class='sidebar'>
          <div class='title'>校区</div>
          <tree @setIds="setIdEvent"></tree>
        </div>
    </el-aside>-->
    <!-- 表格主体 -->
    <el-card v-auth="'teacher_/agentUserInfo/teacherPageList'">
      <el-row :gutter="20" style="margin-bottom: 10px">
        <el-col :sm="12" :md="5" :lg="5">
          <!-- <el-select style="width: 100%;" v-model="searchForm.campusId" placeholder="请选择校区" clearable>
              <el-option
                v-for="item in campusList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
          </el-select>-->
          <el-cascader
            style="width: 100%"
            clearable
            v-model="searchForm.campusId"
            :show-all-levels="false"
            :props="campusTreeProps"
            placeholder="请选择所属校区"
            :options="campusList"
            @change="campusIdChange"
          ></el-cascader>
        </el-col>
        <el-col :sm="12" :md="5" :lg="5">
          <el-input
            v-model="searchForm.name"
            prefix-icon="el-icon-search"
            style="width: 100%"
            placeholder="请输入姓名/手机号"
            clearable
          ></el-input>
        </el-col>
        <el-col :sm="12" :md="5" :lg="5" style="float: right">
          <el-button
            type="primary"
            style="float: right"
            icon="el-icon-search"
            @click="(currentPage = 1), getPageList()"
            >查询</el-button
          >
        </el-col>
        <!-- <el-col :sm="12" :md="5" :lg="5" style="float:right">
          <el-button
            type="primary"
            style="float:right"
            @click="showAddDialog = true;getSubjectTreeList()"
            icon="el-icon-plus"
          >添加教师</el-button>
        </el-col> -->
      </el-row>
    </el-card>
    <el-card class="box-card" v-auth="'teacher_/agentUserInfo/teacherPageList'">
      <el-row>
        <el-col :sm="12" :md="5" :lg="5" style="float: right">
          <el-button
            type="primary"
            style="float: right"
            v-auth="'teacher_/teacher/teacherCalendarInfo'"
            @click="teacherSchedule()"
            >老师排课情况</el-button
          >
        </el-col>
      </el-row>
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        class="teacherTable"
        :data="tableData"
        border
        style="width: 100%; margin-top: 20px"
        prop="date"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="排序"
          width="50"
        ></el-table-column>

        <el-table-column
          prop="campusName"
          label="校区"
          sortable
          width="180"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="教师"
          width="180"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="row">
            <el-row>
              <el-col :span="8">
                <span>
                  <img
                    style="margin-right: 10px"
                    width="40px"
                    height="40px"
                    :src="row.row.headPic ? row.row.headPic : defaultImg"
                  />
                </span>
              </el-col>
              <el-col :span="16">
                <div style="margin-top: 10px">{{ row.row.name }}</div>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
          prop="account"
          label="手机"
          width="150"
        ></el-table-column>
        <el-table-column
          label="擅长科目"
          prop="goodAtSubjectName"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.goodAtSubjectName == 'undefined' ||
                  scope.row.goodAtSubjectName == null
              "
              >无</span
            >
            <span v-else>{{ scope.row.goodAtSubjectName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="老师简介"
          prop="remark"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.remark == 'undefined' || scope.row.remark == null"
              >无</span
            >
            <span v-else>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="详细信息"
          prop="detail"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.detail == 'undefined' || scope.row.detail == null"
              >无</span
            >
            <span v-else>{{ scope.row.detail }}</span>
          </template> </el-table-column
        ><el-table-column width="80" label="状态" align="center">
          <!-- <template slot-scope="scope">
              <el-button type="text" @click="isActive(scope.row)">{{scope.row.enabled==1?'启用':'禁用'}}</el-button>
          </template>-->
          <template slot-scope="scope">
            <el-switch
              v-auth="'teacher_/agentUserInfo/updateTeacher'"
              v-model="scope.row.enabled"
              active-value="1"
              inactive-value="-1"
              @change="isActive(scope.row)"
              class="switchStyle"
              active-text="开"
              inactive-text="关"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column width="60" label="操作" align="center">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="showDialog(scope.row)">编辑<i class="el-icon-edit"></i></el-button> -->
            <!-- <el-button type="text">
                <i class="el-icon-edit icon-style" @click="getSubjectTreeList(),getAgentUserInfo(scope.row.id)"></i>
            </el-button>-->
            <!-- <el-button @click="del(scope.row)" type="text">删除</el-button> -->
            <div class="operationGroup">
              <span
                v-auth="'teacher_/agentUserInfo/updateTeacher'"
                class="el-icon-edit icon-style"
                @click="getSubjectTreeList(), getAgentUserInfo(scope.row.id)"
              ></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table_bottom">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          style="margin-top: 20px; text-align: left"
          background
          layout="prev, pager, next, jumper,  total, sizes"
          :total="total"
          :page-size.sync="pageSize"
          :current-page.sync="currentPage"
        ></el-pagination>
      </div>
    </el-card>
    <!-- 添加教师弹出框 -->
    <el-dialog
      @close="clearForm"
      class="addDialog"
      title="添加教师"
      :width="addwidth"
      :visible.sync="showAddDialog"
    >
      <el-form
        :model="form"
        status-icon
        :rules="rules"
        ref="addForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="校区">
              <!-- <el-select style="width: 100%;" v-model="form.campusId" placeholder="请选择校区" clearable>
                <el-option
                  v-for="item in campusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>-->
              <el-cascader
                style="width: 100%"
                clearable
                v-model="form.campusId"
                :show-all-levels="false"
                :props="campusTreeProps"
                placeholder="请选择所属校区"
                :options="campusList"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="教师姓名" prop="name">
              <el-input
                clearable
                v-model="form.name"
                placeholder="请输入教师姓名"
                auto-complete="off"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="height: 90px">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="擅长科目" prop="goodAtSubjectId">
              <el-cascader
                clearable
                style="width: 100%"
                v-model="form.goodAtSubjectId"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请选择所属科目"
                :options="subjectTreeList"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="教师头像">
              <div class="upload-div">
                <img
                  class="upload-img"
                  :src="form.headPic ? form.headPic : defaultImg"
                  alt
                />
                <div class="upload-content">
                  <div>
                    <el-upload
                      class="crm-upload"
                      :action="fileAction"
                      :on-remove="handleRemove"
                      :on-change="handleChange"
                      :before-upload="beforeUpload"
                      :on-success="UploadSuccess"
                      :headers="upLoadData"
                      list-type="picture"
                      :show-file-list="false"
                    >
                      <div class="content-text">上传头像</div>
                    </el-upload>
                  </div>
                  <div class="content-texts">
                    <span class="content-texts" style="font-size: 10px"
                      >支持JPG、PNG、GIF格式，小于2M</span
                    >
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="手机号码" prop="account">
              <el-input
                clearable
                v-model="form.account"
                placeholder="请输入手机号码"
                auto-complete="off"
                maxlength="13"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="是否启用" prop="enabled">
              <el-radio-group v-model="form.enabled">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="-1">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="教师简介" prop="remark">
              <el-input
                clearable
                v-model="form.remark"
                placeholder="请输入教师简介"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="详细信息" prop="detail">
              <el-input
                clearable
                type="textarea"
                :rows="3"
                v-model="form.detail"
                placeholder="请输入详细信息"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="resetaddForm">重置</el-button>
        <el-button type="primary" @click="addTeacher">提交</el-button>
      </div>
    </el-dialog>
    <!-- 弹出编辑弹出框 -->
    <el-dialog
      @close="clearForm"
      class="addDialog"
      title="编辑教师"
      :width="addwidth"
      :visible.sync="showEditorDialog"
    >
      <el-form
        :model="form"
        status-icon
        :rules="rules"
        ref="updateForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :sm="24" :md="12" :lg="12"
            ><!--  prop="campusId" -->
            <el-form-item label="校区">
              <!-- <el-select style="width: 100%;" v-model="form.campusId" placeholder="请选择校区" clearable>
                <el-option
                  v-for="item in campusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>-->
              <el-cascader
                style="width: 100%"
                clearable
                v-model="form.campusId"
                :show-all-levels="false"
                :props="campusTreeProps"
                placeholder="请选择所属校区"
                :options="campusList"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="教师姓名" prop="name">
              <el-input
                clearable
                v-model="form.name"
                placeholder="请输入教师姓名"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="height: 90px">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="擅长科目" prop="goodAtSubjectId">
              <el-cascader
                clearable
                style="width: 100%"
                v-model="form.goodAtSubjectId"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请选择所属科目"
                :options="subjectTreeList"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="教师头像">
              <div class="upload-div">
                <img
                  class="upload-img"
                  :src="form.headPic ? form.headPic : defaultImg"
                  alt
                />
                <div class="upload-content">
                  <div>
                    <el-upload
                      class="crm-upload"
                      :action="fileAction"
                      :on-remove="handleRemove"
                      :on-change="handleChange"
                      :before-upload="beforeUpload"
                      :on-success="UploadSuccess"
                      :headers="upLoadData"
                      list-type="picture"
                      :show-file-list="false"
                    >
                      <div class="content-text">上传头像</div>
                    </el-upload>
                  </div>
                  <div class="content-texts">
                    <span class="content-texts" style="font-size: 10px"
                      >支持JPG、PNG、GIF格式，小于2M</span
                    >
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="手机号码" prop="account">
              <el-input
                clearable
                v-model="form.account"
                placeholder="请输入手机号码"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="是否启用" prop="enabled">
              <el-radio-group v-model="form.enabled">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="-1">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="教师简介" prop="remark">
              <el-input
                clearable
                v-model="form.remark"
                placeholder="请输入教师简介"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="教师标签" prop="labelListStr">
              <el-input
                clearable
                v-model="form.labelListStr"
                placeholder="教师标签:多个标签逗号分割,最多三个"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="详细信息" prop="detail">
              <el-input
                clearable
                type="textarea"
                :rows="3"
                v-model="form.detail"
                placeholder="请输入详细信息"
                auto-complete="off"
                maxlength="255"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="resetaddForm">重置</el-button>
        <el-button type="primary" @click="updateTeacher">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tree from "./tree";
export default {
  data() {
    let checkMobile = (rule, value, callback) => {
      let mobileReg = /^1[2,3,4,5,6,7,8,9]\d{9}$/;
      if (value == "") {
        callback("手机号不能为空");
      } else {
        if (!mobileReg.test(value)) {
          callback(new Error("手机格式错误"));
        } else {
          callback();
        }
      }
    };
    let checkId = (rule, value, callback) => {
      let IdRgeg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (value == "") {
        callback(new Error("身份证不能为空"));
      } else {
        if (!IdRgeg.test(value)) {
          callback(new Error("身份证格式错误"));
        } else {
          callback();
        }
      }
    };
    return {
      defaultImg:
        "https://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/defaultImg.png",
      fileAction: `${process.env.BASE_URL}/system/uploadFile`,
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      subjectTreeList: [],
      treeData: [], //校区树
      propsxxx: {
        children: "children",
        label: "name"
      },
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      tableData: [], //表格数据
      campusList: [],
      searchForm: {},
      showAddDialog: false,
      showEditorDialog: false,
      addwidth: "60%",
      loading: true,
      campusId: "",
      searchCampusId: null,
      form: {
        campusId: null,
        account: "",
        name: "",
        headPic: "",
        enabled: 1,
        remark: "",
        detail: "",
        labelListStr:""
      },
      editForm: [],
      id: "",
      rules: {
        campusId: [
          {
            required: true,
            message: "请选择校区",
            trigger: "change"
          }
        ],
        goodAtSubjectId: [
          {
            required: true,
            message: "请选择擅长科目",
            trigger: "change"
          }
        ],
        account: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: "blur"
          },
          {
            min: 1,
            max: 11,
            message: "手机号码长度在1到11个字"
          },
          {
            pattern: /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/,
            message: "手机号码格式不正确"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入教师姓名",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "教师姓名长度在1到255个字"
          }
        ],
        enabled: [
          {
            required: true,
            message: "请选择是否启用",
            trigger: "change"
          }
        ],
        headPic: [
          {
            required: true,
            message: "请上传教师头像",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "教师头像长度在1到255个字"
          }
        ],
        remark: [
          {
            required: true,
            message: "请输入简介",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "简介长度在1到255个字"
          }
        ],
        detail: [
          {
            required: true,
            message: "请输入详细信息",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "详细信息长度在1到255个字"
          }
        ]
      },
      pageSize: 10,
      currentPage: 1,
      total: 0, //总的数据数
      start: "",
      end: "",
      pageNumber: [
        {
          value: 10,
          label: 10
        },
        {
          value: 20,
          label: 20
        }
      ]
    };
  },
  components: {
    tree
  },
  computed: {
    upLoadData() {
      return {
        openId: this.$store.state.loginData.openId,
        token: this.$store.state.loginData.token,
        LoginType: "agent"
      };
    }
  },
  methods: {
    teacherSchedule() {
      this.$router.push("/teacherSchedule");
    },
    indexMethod(index) {
      return index + 1 + (this.currentPage - 1) * 10;
    },
    handleRemove(file, fileList) {
      // this.uploadList = fileList;
      // if (this.picUrl.length > 0) {
      //   for (let i = 0; i < this.picUrl.length; i++) {
      //     if (this.picUrl[i].uid == file.uid) {
      //       this.picUrl.splice(i, 1);
      //     }
      //   }
      // }
    },
    handleChange(file, fileList) {
      // this.picUrl = fileList.slice(-1);
    },
    beforeUpload(file) {
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    UploadSuccess(res, file, fileList, val) {
      if (this.showEditorDialog) {
        this.form.headPic = res.data;
        console.log("22222", this.form.headPic);
      } else if (this.showAddDialog) {
        this.form.headPic = res.data;
        console.log("233333333", this.form.headPic);
      }
      // this.picUrl.push({
      //   name: res.data[0].FileName,
      //   url: res.data[0].FilePath
      // });
    },
    //获取校区
    // getCampusList() {
    //   this.api.campus.getCampusList({}).then(result => {
    //     if (result.success) {
    //       this.campusList = result.data;
    //     }
    //   });
    // },
    getCampusList() {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取课程
    getSubjectTreeList() {
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
              }
            } else {
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    campusIdChange() {
      let index = this.searchForm.campusId.length;
      this.searchCampusId = this.searchForm.campusId[index - 1];
    },

    sizeChange() {
      this.pageChange();
    },
    currentChange() {
      this.pageChange();
    },
    pageChange() {
      //分页发生变化时
      let data;
      if (this.inp && !this.campusId) {
        data = {
          pageNumber: this.currentPage,
          pageSize: this.pageSize,
          sortName: "create_time",
          sortOrder: "desc",
          name: this.inp,
          account: this.inp
        };
      } else {
        data = {
          pageNumber: this.currentPage,
          pageSize: this.pageSize,
          sortName: "create_time",
          sortOrder: "desc",
          campusId: this.campusId
        };
      }
      this.api.agentUserInfo.teacherPageList(data).then(result => {
        if (result.success) {
          this.loading = false;
          this.tableData = result.data.records;
        }
      });
    },
    paginationInit() {
      if (this.currentPage == 1 && this.total <= this.pageSize) {
        this.start = 1;
        this.end = this.total;
      } else if (this.currentPage * this.pageSize < this.total) {
        this.start = (this.currentPage - 1) * this.pageSize + 1;
        this.end = this.currentPage * this.pageSize;
      } else if (this.currentPage * this.pageSize >= this.total) {
        this.start = (this.currentPage - 1) * this.pageSize + 1;
        this.end = this.total;
      }
      console.log(this.start, this.end);
    },
    isActive(v) {
      console.log(v.enabled);
      //是否启用
      this.$confirm(
        "您确定要" + (v.enabled === 1 ? "启用" : "禁用") + "吗？",
        "系统消息",
        {
          type: "warning"
        }
      )
        .then(() => {
          console.log("确认", v);
          let data = {
            id: v.id,
            enabled: v.enabled == "1" ? "1" : "-1"
          };
          this.api.agentUserInfo.enabledUser(data).then(result => {
            // console.log(result)
            if (result.success) {
              this.$message.success(result.message);
              this.getPageList();
            } else {
              this.$message.error(result.message);
            }
          });
        })
        .catch(() => {});
    },
    getPageList() {
      //获取表格数据
      let data = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        sortName: "create_time",
        sortOrder: "desc",
        campusId: this.searchCampusId,
        account: this.searchForm.name,
        name: this.searchForm.name
      };
      this.campusId = "";
      this.loading = true;
      // console.log(data)
      this.api.agentUserInfo.teacherPageList(data).then(result => {
        if (result.success) {
          this.tableData = result.data.records;
          for (let item of this.tableData) {
            item.enabled = String(item.enabled);
          }
          this.total = Number(result.data.total);
          this.paginationInit();
          this.loading = false;
        }
      });
    },
    getAgentUserInfo(id) {
      this.api.agentUserInfo
          .getAgentUserInfo({
          id: id
        })
        .then(result => {
          this.form = result.data;
          try {
            this.$refs.updateForm.clearValidate();
          } catch (error) {}
          if (!this.form.headPic) {
            this.$set(this.form, "headPic", "");
          }
          console.log("this.form ", this.form);
          this.showEditorDialog = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    setIdEvent(val) {
      //点击校园树
      console.log(val);
      this.campusId = val.id;
      this.pageSize = 10;
      this.currentPage = 1;
      let data = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        sortName: "create_time",
        sortOrder: "desc",
        campusId: val.id
      };
      this.loading = true;
      this.api.teacher.pageList(data).then(result => {
        console.log(result);
        if (result.success) {
          this.loading = false;
          this.tableData = result.data.records;
        }
      });
    },
    // setaddDialogwidth() {
    //   //设置添加老师弹窗大小
    //   var width = document.body.clientWidth;
    //   if (width < 560) {
    //     this.addwidth = "80%";
    //   } else if (width < 790) {
    //     this.addwidth = "70%";
    //   } else if (width < 970) {
    //     this.addwidth = "50%";
    //   } else if (width < 1300) {
    //     this.addwidth = "40%";
    //   } else {
    //     this.addwidth = "30%";
    //   }
    // },
    addTeacher() {
      //添加老师
      this.$refs.addForm.validate(val => {
        console.log(val);
        if (val) {
          let index = this.form.campusId.length;
          this.form.goodAtSubjectId = this.form.goodAtSubjectId[1];
          this.form.campusId = this.form.campusId[index - 1];
          this.api.agentUserInfo.addTeacher(this.form).then(result => {
            console.log(result);
            if (result.success) {
              this.$message.success("添加成功");
              this.clearForm();
              this.showAddDialog = false;
              this.getPageList();
            } else {
              this.$message.error(result.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 重置
    resetaddForm() {
      this.$refs.addForm.resetFields();
    },
    del(params) {
      //删除教师
      // console.log(params.id);
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.teacher
            .deleteTeacher([
              {
                id: params.id
              }
            ])
            .then(result => {
              console.log(result);
              if (result.success) {
                this.$message.success(result.message);
                this.getPageList();
              } else {
                this.$message.error(result.message);
              }
            });
        })
        .catch(() => {});
    },
    showDialog(row) {
      //弹出编辑框
      this.showEditorDialog = true;
      this.form = {
        name: row.name,
        goodAtSubjectId: row.goodAtSubjectId,
        account: row.account,
        enabled: row.enabled,
        agentId: row.agentId,
        idCard: row.idCard,
        campusId: row.campusId,
        remark: row.remark,
        detail: row.detail,
        headPic: row.headPic
      };
      this.id = row.id;
    },
    updateTeacher() {
      //教师信息编辑
      this.$refs.updateForm.validate(value => {
        console.log(value);
        if (value) {
          if (typeof this.form.campusId == "object") {
            let index = this.form.campusId.length;
            this.form.campusId = this.form.campusId[index - 1];
          }
          if (typeof this.form.goodAtSubjectId == "object") {
            this.form.goodAtSubjectId = this.form.goodAtSubjectId[1];
          }
          var self = this;
          var form = {};
          Object.assign(
            form,
            {
              id: this.id
            },
            this.form
          );
          console.log(form);
          this.api.agentUserInfo.updateTeacher(form).then(result => {
            console.log(result);
            if (result.success) {
              this.$message.success(result.message);
              this.showEditorDialog = false;
              this.clearForm();
              this.getPageList();
            } else {
              this.$message.error(result.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    clearForm() {
      this.form = {
        campusId: null,
        account: "",
        name: "",
        headPic: "",
        enabled: 1,
        remark: "",
        detail: ""
      };
    }
  },
  created() {
    // this.getTreeData();
    this.getCampusList();
    this.getPageList();
  },
  mounted() {
    // window.onresize = () => {
    //   this.setaddDialogwidth();
    // };
  }
};
</script>

<style scoped>
.teacherManger {
}

.teacherManger .el-radio {
  margin-right: 10px;
}
.el-input--suffix .el-input__inner {
  padding-right: 20px;
}

.sidebar,
.sidebarRight {
  background: white;
  padding: 0 20px 20px 0;
}

.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}

.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}

.teacherManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}

.addDialog .el-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
}

.addDialog .dialogLeft {
  text-align: right;
  padding-right: 10px;
}

.addDialog .el-dialog__body {
  padding: 15px 20px !important;
}

.table_bottom {
  margin: 20px 0;
}
.upload-img {
  width: 80px;
  height: 80px;
}
.plan-icon {
  font-size: 16px;
  color: #4d94ff;
  margin-right: 10px;
}
</style>
<style lang="less" scoped>
.list-name-img {
  display: flex;
  flex-direction: row;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    margin-right: 10px;
  }
}
.upload-div {
  display: flex;
  flex-direction: row;
  .upload-img {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    border: 1px solid rgb(238, 238, 238);
  }
  .upload-content {
    margin-left: 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .content-text {
      width: 80px;
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      border: 1px solid rgb(77, 148, 255);
      color: rgb(77, 148, 255);
      font-size: 12px;
    }
    .content-texts {
      color: rgb(162, 170, 188);
      font-size: 12px;
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/index.vue